import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';
import useItemQuantity from '@store/item/hooks/useItemQuantity';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import { itemActions } from '@store/item/itemSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface Props {
    itemId: string;
}

function AmountRow({ itemId }:Props) {
    const { itemMaxQuantity } = useAppCustom().item;
    const dispatch = useDispatch();
    const activityId = useItemActivityId();
    const itemQuantity = useItemQuantity(itemId);
    const { totalAmount } = useCalculatedOrder();
    const { t } = useTranslation('item');
    const priceUnit = usePriceUnit();
    return (
        <Container justify='space-between'>
            <StepperWrapper>
                <Stepper value={itemQuantity}
                    max={itemMaxQuantity}
                    min={1}
                    increase={() => dispatch(itemActions.updateItemQuantity({
                        activityId, itemId, amount: 1,
                    }))}
                    decrease={() => dispatch(itemActions.updateItemQuantity({
                        activityId, itemId, amount: -1,
                    }))} />
            </StepperWrapper>
            <Text size='3xl' fontWeight='bold' color={colors.red}>
                {totalAmount.toLocaleString()}{priceUnit}
            </Text>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 0  0 16px;
`;

const StepperWrapper = styled.div`
    width: 120px;
`;

export default AmountRow;
